// extracted by mini-css-extract-plugin
export default {"programItemBlock":"ProgramItemBlock_programItemBlock__f+AvR","textContainer":"ProgramItemBlock_textContainer__m2efM","richText":"ProgramItemBlock_richText__V-ifD"};